import styled from 'styled-components';

import Clearfix from '../Clearfix';

const Row = styled(Clearfix)`
  margin-right: -15px;
  margin-left: -15px;
`;

export default Row;



// WEBPACK FOOTER //
// ./src/shared-components/atoms/Row/index.js